module.exports = __webpack_public_path__ + "img/image22.9e08af1b.jpg";